import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

// 路由表
const routes = [
  { path: '/', name: 'Work', component: () => import(/* webpackChunkName: "work" */ '@/views/work/index.vue'), redirect: { name: 'GuideStation' }, children: [] }, //主界面

  { path: '/login', name: 'Login', component: () => import(/* webpackChunkName: "login" */ '@/views/login/login.vue') }, //登录界面
  { path: '/register', name: 'Register', component: () => import(/* webpackChunkName: "register" */ '@/views/login/register.vue') }, //注册界面
  { path: '/forgot', name: 'Forgot', component: () => import(/* webpackChunkName: "forgot" */ '@/views/login/forgot.vue') }, //忘记密码界面

  {
    path: '/policies',
    name: 'Policies',
    component: () => import(/* webpackChunkName: "policies" */ '@/views/policies/index.vue'),
    redirect: { name: 'PoliciesService' },
    children: [
      { path: 'service', name: 'PoliciesService', component: () => import(/* webpackChunkName: "policies-service" */ '@/views/policies/service.vue') } //协议界面
    ]
  },

  { path: '*', name: 'NotFound', component: () => import(/* webpackChunkName: "404" */ '@/views/404.vue') } //404界面
]

//动态加载子路由
const routerContext = require.context('../../views', true, /router\.js$/)
routerContext.keys().forEach(route => {
  const routerModule = routerContext(route)
  routes[0].children?.push(...(routerModule.default || routerModule))
})

//创建路由
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//路由守卫
router.beforeEach((to, from, next) => {
  if('|Login|Register|Forgot|Policies|PoliciesService|NotFound|'.indexOf(to.name) === -1 && !store.state.token.token) {
    next({ name: 'Login' })
  } else {
    next()
  }
})

//push多次异常处理
const originPush = VueRouter.prototype.push
VueRouter.prototype.push = function (location, resolve, reject) {
  return originPush.call(this, location, resolve ? resolve : ()=>{}, reject ? reject : ()=>{})
}

export default router